import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Email } from '../../graphql/emails.datatypes'
import {updateCacheByType} from "../../graphql/GraphQlProvider";

export interface CreateEmailInput {
    data: {
        email: string;
    };
}

interface CreateEmailData {
    createEmail: Email;
}

export const CREATE_EMAIL_MUTATION = gql`
  mutation createEmail($data: CreateEmailInput!){
    createEmail(data: $data) {
      id
      email
    }
  }
`;

export const createEmail = () => {
    return useMutation<CreateEmailData, CreateEmailInput>(
        CREATE_EMAIL_MUTATION,
        {
            update: updateCacheByType('Email'),
        }
    );
};

export default createEmail;
